const debug = require('debug')('ccs:main');
import './http';
import './i18n';
import './progress_bar';
import './filter';
import Vue from 'vue';
import ElementUI from 'element-ui';
import './models/element-ui/index.css';
import './main.less';
import eleEnLang from 'element-ui/lib/locale/lang/en';
import eleLocale from 'element-ui/lib/locale';
import './models/iconfont/iconfont.css';
import router from './router';
import App from './app.vue';
import { isProd } from './utils';

if (!isProd()) {
	// require('./mock');
}

// 设置语言
eleLocale.use(eleEnLang);

Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.prototype.$hasMenu = function (menu) {
	debug('$hasMenu', menu);
	if (!window.__USER || !Array.isArray(window.__USER.menus)) return false;
	return window.__USER.menus.map(({ code }) => code).includes(menu);
};

Vue.prototype.$hasPermission = function (permission) {
	debug('$hasPermission', permission);
	if (!window.__USER || !Array.isArray(window.__USER.permissions)) return false;
	return window.__USER.permissions.map(({ code }) => code).includes(permission);
};

Vue.prototype.$getUser = function () {
	return window.__USER;
};

const app = new Vue({
	el: '#app',
	router,
	components: { App }
});

export {
	app
};